export default "__VITE_ASSET__3a8bd2a8__"